import { has, get } from 'lodash';
import moment from 'moment';
import { DAILY_LIMIT_ERROR_CODE, TRANSACTION_LIMIT_ERROR_CODE, dateFormat } from '../../config';

export const isBiller = (state, id) => {
	const payee = state.payees.find((payee) => payee.id === id);
	return has(payee, 'biller_id');
};

export const getPayeeById = (state, id) => {
	const payee = state.payees.find((payee) => payee.id === id);
	return { ...payee, isBiller: has(payee, 'biller_id') };
};
// FIXME: below function is just for temporary use will need to fix this in future. This is just not to break any existing stuff.
export const getBeneficiaryByIdForTemplates = (state, id) => {
	const payee = state.payees.find((payee) => payee.id === id);
	if (payee) {
		payee.isBiller = has(payee, 'biller_id');
	}
	return payee;
};

export const unauthorisedDailyLimitFilter = (payment) =>
	get(payment, 'authorisation.error.code', 0) === DAILY_LIMIT_ERROR_CODE;

export const unauthorisedTransactionLimitFilter = (payment) =>
	get(payment, 'authorisation.error.code', 0) === TRANSACTION_LIMIT_ERROR_CODE;

export const toFormattedDate = ({ date }) => moment(date).format(dateFormat);

export const toDistinctDates = (dates, formattedDate) => {
	if (dates.indexOf(formattedDate) === -1) {
		return [...dates, formattedDate];
	}
	return dates;
};

export const fromPaymentToDateListItem = (date, index) => ({ id: index + 1, text: moment(date).format(dateFormat) });

export const isStateDateInvalid = (stateDate, apiDate) =>
	!moment(stateDate).isValid() || moment(apiDate).isAfter(moment(stateDate));
